import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { apiCommon } from 'lib/utils/axios';
import { getBrowserLocale } from 'lib/utils/locale';
import { getQueryParamsAsObject } from 'lib/utils/url';
import validate from 'lib/utils/validationRules';

Vue.use(VueI18n);

let loadedLanguages = [];

export function initI18n() {
  const languageCode = getLocaleCode();

  return loadLocalization()
    .then(localization => {
      setI18nLanguage(languageCode);
      loadedLanguages.push(...Object.keys(localization));

      return new VueI18n({
        locale: languageCode,
        fallbackLocale: languageCode,
        messages: localization,
        pluralizationRules: {
          /**
           * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
           * @param choicesLength {number} an overall amount of available choices
           * @returns a final choice index to select plural word by
           */
          // eslint-disable-next-line complexity
          'ru': (choice, choicesLength) => {
            // this === VueI18n instance, so the locale property also exists here
            if (choice === 0) {
              return 0;
            }

            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
              return (!teen && endsWithOne) ? 1 : 2;
            }
            if (!teen && endsWithOne) {
              return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
              return 2;
            }

            return (choicesLength < 4) ? 2 : 3;
          },
        },
      });
    });
}

export function loadLocalization() {
  return apiCommon.get('localization')
    .then(response => response.data)
    .catch(error => {
      console.error(error);
    });
}

export function loadLanguage(lang) {
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  return apiCommon.get(`locale?language=${lang}`)
    .then(response => {
      setI18nLanguage(lang);
      loadedLanguages.push(lang);

      return response.data.localization;
    })
    .catch(error => {
      console.error(error);
    });
}

export function getLocaleCode() {
  const langInUrl = getQueryParamsAsObject(decodeURIComponent(window.location.search.slice(1)));
  const langInStorage = JSON.parse(localStorage.getItem('lang'));
  const browserLocale = getBrowserLocale({ languageCodeOnly: true });

  if (validate.isObjectWithFields(langInUrl, ['lang'])) {
    return langInUrl.lang.toLowerCase();
  }

  if (validate.isObjectWithFields(langInStorage, ['code'])) {
    return langInStorage.code.toLowerCase();
  }

  return browserLocale || process.env.VUE_APP_I18N_LOCALE;
}

function setI18nLanguage(lang) {
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}
